import { render, staticRenderFns } from "./MenuItemPeriod.vue?vue&type=template&id=646a901e&scoped=true&"
import script from "./MenuItemPeriod.vue?vue&type=script&lang=js&"
export * from "./MenuItemPeriod.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemPeriod.vue?vue&type=style&index=0&id=646a901e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a901e",
  null
  
)

export default component.exports